export const routes = {
  home: "",
  about: "/#about",
  Services: "/#services",
  digitalSolutions: "/#digital-solutions",
  businessSolutions: "/#business-solutions",
  supplyTrading: "/#supply-trading-solutions",
  ContactUs: "/#ContactUs",
};
